/*
 * 作品案例搜索页顶级组件
 * @author: linbenjian
 * @date: 2018-07-13 14:05:13
 */
import './app-case-search.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';

import Searchbox from 'components/app-case/searchbox';
import Concordance from 'components/app-case/concordance';
import Breadcrumb from 'components/app-case/breadcrumb';
import SearchList from 'containers/app-case/search-list';
import CaseList from 'containers/app-case/case-list';
import GotoTop from 'components/goto-top';
class AppCaseSearch extends Component {
  static propTypes = {
    userInfo: PropTypes.object,
    // 关键字Id
    keywordId: PropTypes.number,
    // 关键词
    keyword: PropTypes.string,
    // 搜索案例结果总数
    total: PropTypes.number,
    // 热门搜索词
    hotWords: PropTypes.array,
    // 相关搜索词
    relWords: PropTypes.array,
    // 封面图
    cover: PropTypes.array,
    // 设置关键字
    setKeyword: PropTypes.func,
  };

  constructor() {
    super();
    this.state = {
      // 是否为搜索页
      isSearch: false,
    };
  }

  componentDidMount() {
    if (this.props.keyword) {
      this.initStat();
    }
  }

  // 统计作品案例结果搜索页
  initStat = () => {
    const { total, keyword } = this.props;
    sendStat('RP_STORE', '作品案例', '搜索结果页-页面访问', Stat.ACTION_INIT, {
      id: 'web_apppreview_searchresult_preview',
      keyword: keyword,
      result: total > 0 ? '1' : '0',
    });
  };

  hideSearchInput() {
    const whiteList = window.RPCONFIG.appCaseSearchWhiteList;
    const { userInfo = {} } = this.props;
    return !(whiteList && whiteList.includes(userInfo.userId));
  }

  render() {
    const { total, keyword } = this.props;
    // 通过状态中的关键字判断是否是搜索结果页。有关键字-是，无关键字-不是
    const isSearch = !!keyword;
    return (
      <div className="app-case-search">
        <div className="header">
          {/* 临时关闭案例搜索入口 2019-9-18 */}
          <Searchbox
            {...this.props}
            closeSearchInput={this.hideSearchInput()}
          />
          {isSearch ? (
            <div>
              <Concordance {...this.props} />
              <Breadcrumb keyword={keyword} total={total} />
            </div>
          ) : null}
        </div>
        <div className="body">
          {isSearch ? <SearchList /> : <CaseList listType={0} />}
          <GotoTop />
        </div>
      </div>
    );
  }
}
export default AppCaseSearch;
